var _style, _defs, _g, _circle, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpain = function SvgSpain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Spain_svg__S{fill:#e4ad23}.Spain_svg__T{fill:#e31e27}.Spain_svg__U{fill:#fff}.Spain_svg__V{fill:#7f2418}.Spain_svg__W{fill:#3962ab}.Spain_svg__X{fill:#008e6f}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Spain_svg__A"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(279 -120 100)",
    cx: -119.9,
    cy: 100,
    r: 98.1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Spain_svg__B"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(315 100 100)",
    cx: 100,
    cy: 100.2,
    r: 98.1,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Spain_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-267 2H27v196h-294z",
    fill: "#ffd276"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(315 100 100)",
    cx: 100,
    cy: 100.2,
    r: 98.1,
    fill: "none",
    stroke: "#a5a7aa",
    strokeWidth: 1.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Spain_svg__B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-36 2h294v196H-36z",
    fill: "#e41e26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 51h294v98H-36z",
    fill: "#fed500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81 79-2 4-4 3H49l-4-2-2-3v-1l-1-1c2-2 5-3 8-3 6 0 4-2 12-2s6 2 12 2c3 0 6 1 7 3z",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62 85-14 1 14-2 13 2h1-1l-13-1m0-4 2 2 2-1v-1 1l2 2 2-2 1-1v2l2 1 1-1v1l1 1 2-1 1-1-1 2h-2l-1-1-1 1c-2 0-3-1-3-2l-2 1-2-1-2 1-2-1-3 1-2-1-2 1-2-1-2 2-2-1-1 1h-2l-1-2 1 1 2 1 1-1v-1l2 1 1-1v-1l1-1v1l2 2 2-2v-1 1l2 1 2-2m10-4v1l-1-1 2-3c0-2-3-3-5-3l-4 1v-1l4-1c3 0 5 2 5 4zm-18 0-2-3c0-2 3-4 6-4l3 1h-3c-3 0-5 1-5 3l2 3-1 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 70 1 1v2l1 3-2 2-2-2v-5l2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1l1 1v4l-1 1-2-1 1-3v-2l1-1m9 7c1 0 2-1 2-3s-1-2-2-3l1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80 79 1-3v-1c-1-2-4-3-7-3h-2v1l2-1c3 0 6 2 6 3l1 1-2 3 1 1h1l-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79 73 2 2v5l1-3-3-4m-26 4-2-3 2-3-3 3 2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1l1-1-1-3v-1c1-1 3-3 6-3l2 1v-1h-2c-3 0-6 1-7 3v1l1 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 73-2 4v3l1-1-1-3v-1l2-2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 80h1v1zm0-1h1l-1 1zm-1-1h1zm0-1 1-1v1zm1-2v1zm0-1h1v1zm1-1h1v1zm1 0 1-1v1zm1-1h1zm2-1h1l-1 1zm1 0h1l-1 1zm1 0h1zm2 0h1l-1 1zm1 0h1l-1 1zm-1 1h1v1l-1-1m0 2 1-1-1 1m0 1 1-1v1h-1m1 1h-1m1 1h1-1m1-7h1l-1 1zM53 70l1-1v1zm2-1v1l-1-1zm1 0h1-1zm1 0h1zm2 0v1zm1 1v-1l1 1zm1 6h1v1zm0-1 1-1v2l-1-1M61 74l1-1v1l-1-1m0-1h1v1l-1-1m0-1h1-1m21 10-1-1h1zm0-1v-1h1zm1-2h-1 1zm0-1h-1l1-1v1zm-1-1v-1h1zm0-1-1-1h1zm-1-1v-1zm-1-1v-1zm-1-1h-1l1-1zm-2 0v-1h1zm-1 0v-1zm-1 0-1-1h1zm-2 0v-1h1zm-1 0v-1zm1 0v1l-1-1h1m0 2h-1l1-1m0 2v-1 1m0 1h-1 1m-1 1h-1 1m-1-6v-1zm-1-1h-1l1-1v1zm-1 0-1-1h1zm-2 0v-1h1-1zm-1 0v-1zm-1 0-1-1h1zm-2 0v-1l1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m60 68 2-2 1 2-1 2-2-2",
    className: "Spain_svg__W"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 68h-2v-3h1v-1h-1v-1h-1v1h-1v1h1v3h-1zM52 82v-1l-1-1h-1v1l-1 1h2zm10-1 1-1h-1l1-1h2l-1 1h2l-2 1 1 1h-1l-1-1zm-14 1h-1v-1h-1l-1 1v1-2l-1-1v1l-1-1-1 2h1l1 1h4-1zm6-1-1-1h1l1-1v1h2l-2 1 1 1h-2zm7 0v-1l-1-1h-1v1h-1l1 1v1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63 78-1-2-1 2h-1l1 1v1l1-1 1 1v-3zm-10 0v1l-1-2v2h-1l1 1h2v-2zm17 3v-1l-1-1v1h-2l1 1v1h1zm2-2-1-2-1 2v-1 2h1v1l1-1v-1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 82h1l-1-1v-1h1-2l-1 1 1 1zm8-2-1 1v-1l-1 1v2l-2-2v1h-2l1 1h3l1-1 2-1-2-1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m52 81 1-1 1 1-1 1-1-1m18 0 1-1 1 1-1 1-1-1m9 2-1 1h1v-1m-35 0h1v1h-1v-1m17-3 1-1 1 1-1 1-1-1",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62 91-12-1-1-1h1l12-2 12 2v1l-12 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 87-12 2-1-2-1-1 14-1 13 1-1 1v2l-12-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 83v-1l-1 1v1l1-1m-8-2h-1v1l1-1m-10 0h1l-1 1v-1m-8 2v-1 2-1m9 3h1-1c-1 0 0 0 0 0",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1l1-1h2l1 1z",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 86h-2v1l2-1h1z",
    className: "Spain_svg__X"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 87v-1 1",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 88v-1h2z",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69 87 1-1h-3v1z",
    className: "Spain_svg__X"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 86h1-1m6 1 1-1v1h-1",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 88-1-1h-1l1 1zm-13 2-11-1 11-1 11 1-11 1m29-1h-4v-1h2l1-1 1 1 1-1 2 1h1v1l-1 1v-1s0 1 0 0h-3",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94 89h-6zM91 88v1l1-1v1h2s0 1 0 0h-7 2v-1l1 1v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 87v-1l1 1-1 1v-2 2-1m0-1h1-1m0 0v-1 1h1zm-3 4 3-1 3 1h-6m3 1h3v-1h-3l-2 1h-1 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91 89-3 1 3-1 3 1-3-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m91 90-2 1h5zm0 0h1z",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 90h1z",
    className: "Spain_svg__X"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 89v-1z",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 89v-1z",
    className: "Spain_svg__S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 88v1zm-2 0v1z",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93 87h1zm0 0h1-1c-1 0 0 0 0 0zm0-1v1zm-1 0h1-1c-1 0 0 0 0 0zM95 88h1-1c-1 0 0 0 0 0zm0-1h1-1c-1 1 0 1 0 0zm-1 0v-1l1 1h-1c-1 0 0 0 0 0zm0 0v-1 1zm-6 0h1zm0 0h1zm1-1v1zm0 0h1zM86 88h1zm1-1 1-1v1zm1 0v-1 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90 88h-2v1h1v-1zm-3 1h1v-1zm4-1v-1 1h-1 2zm3 0h-1 1-2 1l1 1zm1 0-1 1h1zm-8 0v1zm8 0v1-1h1z",
    className: "Spain_svg__S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 89v-1z",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 89h1c1-1-1-2-2-2l-2-1-3 1c-1 0-3 1-1 2z",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 89h-2v-1l-2-1 1-1 2 2h2l2-2v1l-1 1v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 87 1-1v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 87 1-1v2zm0-1 1-1v1h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 86h-1 1v-1h-1 1zm3 3-3-1-3 1zM30 90l3-1 3 1-1 1-2-1-3 1v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 91h3l-1-1h-2l-3 1zM33 88v1h1v-1 1h2v1h-1v-1h-5l-1 1-1-1h2v-1 1h1v-1 1l1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 89-3 1 3-1 3 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 90h-1z",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 90h-1 1",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 90h-1zm4 0h-1z",
    className: "Spain_svg__X"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 90h-1zm-3 1h-3l3-1 2 1z",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 89h-1zv-1z",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 89v-1z",
    className: "Spain_svg__S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 88v1zm0 0v1zm-2 0-1 1h1l-1-1zm-2 1s-1 0 0 0",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33 87-1 1h1zm-1 1h1zm-1 0h-1 1-1zm-1 1 1-1h-1zm1-1v1zm-2 1v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 88h1v1zm5 1v-1zm-1-1v1h1zm2 1h1l-1-1zm-1-1v1zm-6 1h-1v-1h1zm8 0v-1zM36 89h1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37 89h-1c-1 0 0 0 0 0m1 0h-1z",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 127h6V96h-7v31Z",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28 119-2 2h1l1 2v-2l-1-2m15-11a19 19 0 0 0-9-1c-4 0-7 2-7 3l-1-3c0-2 3-3 7-4a25 25 0 0 1 10 1v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 112-4-2 2-2 2 1v3m6-3 2 1-2 2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 118c-1-1 1-2 4-3l3-1c3-2 6-3 5-4l1 3c0 1-2 3-5 4l-8 4v-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m29 106 1-1h-2l1 2zm0-1h1l-1 1zm3-1h-1v2h2-1zm3 2 1-3-1 2-1-1h-1zm4-2-1-1-1 1 1 2-1-1v1l2-1-2-1h1",
    className: "Spain_svg__S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 132h-2l-1-1-2 1h-3l-1-1-2 1h-1v1l1-1h3l2 1h1l2-1h1l2 1v-1",
    className: "Spain_svg__W"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 133h-2l-1-1h-2l-1 1-2-1h-3l-1 1v1l1-1h3l2 1 1-1h3l2 1v-1",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 134h-2l-1-1h-2l-1 1h-2l-1-1h-2l-1 1v1l1-1h3l2 1 1-1h3l2 1v-1",
    className: "Spain_svg__W"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 136-2-1h-3l-1 1-2-1h-3l-1 1v-1l1-1h3l2 1 1-1h3l2 1",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 137-2-1h-3l-1 1-2-1h-4l1-1h11v1",
    className: "Spain_svg__W"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29 128-1 1h9l-1-1h-7M29 127h7v1h-7v-1m-1 5h9v-3h-9zm0-39h9v-2h-9zm1 2h7v-1h-7 1l-1 1h7v1h-7v-1M29 93h7v1h-7v-1m58 0h8v-2h-8zm8 2h-7v-1h7-1v1m-6 0h7l-1 1h-6l-1-1h1M88 93h6l1 1h-8l1-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85 132h1l2-1 1 1h3l2-1 1 1h2v1l-2-1h-3l-1 1h-2l-1-1h-2l-1 1v-1",
    className: "Spain_svg__W"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 133h1l2-1h1l2 1 1-1h3l2 1v1l-2-1h-3l-1 1-2-1h-3l-1 1v-1",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 134h1l2-1h1l2 1h1l2-1h1l2 1v1l-2-1h-3l-1 1-2-1h-3l-1 1v-1",
    className: "Spain_svg__W"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85 136 1-1h3l2 1 1-1h3l2 1v-1l-2-1h-3l-1 1-2-1h-3l-1 1",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85 137 1-1h3l2 1 1-1h5l-2-1H85v1",
    className: "Spain_svg__W"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95 128 1 1h-9l1-1h7M88 127h6l1 1h-8l1-1m-1 5h8v-3h-8v2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m96 119 2 2h-1l-1 2-1-2 1-2",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 127h6V96h-6z",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 108a20 20 0 0 1 10-1c4 0 7 2 6 3l2-3c0-2-3-3-7-4a25 25 0 0 0-11 1v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94 112 3-2-1-2-2 1v3m-6-3-2 1 2 2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98 118-4-3-3-1-6-4v3c0 1 2 3 5 4l4 2c2 0 4 1 3 2l1-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m85 106 1-2-1 1-1-1h-1zm3-2h-1c-1 0 0 0 0 0v2h2-1zm3 0h-2 1v2-2m2 2v-1l1 1v1h1v-1l-1-1h1v-1h-2l-1 2m2-2v1h-1zm3 3v1h1v-3 1l-3 1zm-1 0 1-1v1z",
    className: "Spain_svg__S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 137-15-3c-3-2-5-5-5-8v-13h40v13c0 3-3 6-6 8-4 2-9 3-14 3",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 131h-2v1l-1 1 2 2 2-2z",
    fill: "#ffd691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 135h-3 1l1 1h3zm4 0-2 1h3l1-1h1z",
    className: "Spain_svg__X"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62 132-1 1 1 1 1-1z",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 135v2-1 1z",
    className: "Spain_svg__X"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 91H42v35c0 5 5 9 10 9s10-4 10-9z",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 113h-2v18l2-5zm-15 0v20l2 1v-21zm-5 0v13l2 5v-19h-2Zm13 0v21l2-1v-20zm-4 0v22h2v-22zm9 0H44",
    className: "Spain_svg__S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 113h19V91H63v22Z",
    className: "Spain_svg__U"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 113v13c0 5-5 9-10 9s-10-4-10-9v-13h20",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 123h-2v-1h2l-2-2 2 2v-3h1v3l2-2h1l-2 2h1v1h-2l2 2v1l-2-2v3h-1v-4l-2 3v-1l2-2m3 8h-2v-3h-1v3h-2v1h2l1 1 1-1h1zm-2 1h-1l1-1zm6-4v-2l-1 2-2-2 1 2v1l-1 1v1l2-1 1-1zm0 1h-1v-1zm1-6-1-1v-3 3h-3v1h3v2-2l1-1zm-1 0v-1l1 1zm0-9-1 1h-2v1h2l-2 2v1l3-3v2-2l1-1zm0 2v-1h1zm-5-1-1-1-1 1h-2v1h2v2h1v-2h2v-1zm-1 1-1-1h1zm-6 0h2v-1h-2l-1-1-1 1 1 1v3-3l3 3zm-1 0v-1h1zm1 6h-1v-2 2l-1 1 1 1v1-1l1-1h2v-1zm-1 1v-1l1 1zm2 6v-1l2-1-1-1-2 2-1-2v4h1l2 1-1-1zm-1 0v-1l1 1zm-1-2h-1v-2h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 125h1v2h-1zm0-7h-1v2h1v-2h1v2h-1v-2m5-2h-3 3m0-1-1-1h-1l-1 1h3m-2 15 2 1v-1h-2m-1 1 2 1-2-1m1-4h1l1-1v-1l-2 2m0-1h-1l2-1-1 1m10 1h1v-2h-1zm0-2h-1v2h1v-2m-2 5-2 1-1-1h2m1 1-2 1 2-1m2-13h-1v2h1v-2m1 0v2-2m-4 9h-1l-1-1 1-1 1 2m1-1-1-1h-1l2 1m-8-8h1l1 1v1l-2-2m0 1h-1l1 2 1-1-1-1m7-1h-1l-1 1 1 1 1-2m1 1-1 2-1-1 2-1m-9 3h3-3m0 1 1 1h1l1-1h-3m9-1h-2 2m0 1v1h-2v-1h2m-4 6h1v-2h-1v2m-1 0v-2 2m0-12v2-2m1 0h1v2h-1v-2m2-1h2-2m0-1v-1h2v1h-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m71 123 1-1 1 1-1 1-1-1",
    className: "Spain_svg__X"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 96v-1h-1v2h1v1h-2v3h1v6h-1v3h11v-3h-2v-6h1v-3h-1v-3 1h-1v-1 1h-1v-1 3h-1v-5 1h-1v-1 1h-1v-1 5h-1v-1h1v-2h-1v1-1h-1zm-2 14h11m-11-1h11m-11-1h11m-11-1h11m-11 0h11m-10-1h8m-8-1h8m-8-1h8m-8 0h8m-8-1h8m-8-1h8m-8 0h8m-9-1h10m-10-1h10m-10-1h10m-10 0h10m-8-1h7m-5-1h2m-2-1h2m-2 0h2m-2-1h2m-2-1h3m-5 3h1m-2-1h3m-3 14v-1m0-1v-1m-1 1v1m2 0v-1m0 2v-1m0-1v-2m0-1v-1m0 3v-1m-2 1v-1m4 1v-1m-2-1v1m1-1v1m1-1v1m0-1v-1m0-2v1m-3-3v1m1-1v1m2-1v1m0-2v1m-1-1v1m-1-1v1m0-3v1m7-1h-2m2-1h-2m2 14v-1m0-1v-1m1 1v1m-1 0v-1m-1 2v-1m0-1v-2m0-1v-1m1 3v-1m1 1v-1m-3 1v-1m2-1v1m-2-1v1m-1-1v1m1-1v-1m-1-2v1m3-3v1m-1-1v1m-1-1v1m-1-2v1m1-1v1m2-1v1m-1-3v1m-3 7v-2m0-2v-1m0-3v-2m-3 2h1m1-2h2m1 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 110v-2c0-1 0-2-2-2s-2 1-2 2v1h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 108h-1v-1h1zm2 0h1v-1h-1zm-1-1 1-1h-2zm-1-2v-2l-1-1-1 1v2zm3 0v-2l1-1 1 1v2zm-1-5v-2h-2v2zm1 0v-2h2l-1 2zm-4 0v-2h-2l1 2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53 110v-2l-1-1-1 1v2zm-2-6v-1l-1-1-1 1v1zm3 0v-1l1-1v2z",
    className: "Spain_svg__W"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 112c0-4 2-7 6-7s6 3 6 7-3 8-6 8-7-4-7-8",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 112c0-2 2-5 5-5s4 3 4 5-2 6-4 6-5-3-5-6",
    className: "Spain_svg__W"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 111h-1v-2l-1 1 1 1h-2l1 1v1h1v-1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 113h2v-1h-2zm6-2h-1v-2l-1 1 1 1h-2 1v1h1v1h-1 2-1v-1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 113h2v-1h-2zm0 1h-1v-2l-1 2 1 1-1-1-1 1h1v2l1-1v1-1 1-1l1-1zm-2 2h2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65 97h-1 1v-1m7 0h-1l-1-1h-2l1 1h3",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79 94-1 1-1-1v9l-3-1-1-3 1 1v-2l1 1v-1 1-4l-2-2-1 1h-1v1h1v1h-1v1h-3l-1-1v-1h-2v1h1-1v1h1l1 1h-1 1-1l3 1-1 1h-2v1q0 1.5 0 0v1h1v-1h1v1l2-2 1 1v1l2 1h-3v2-1 1h1v1h-1v-1h-1v1h-1l1 1h3v-2h1l1 2v-1l1 1v-1 2h-1 1l-1 1h2v-2l1-1h-1l-1-1 2-2 1-2-1-2v-2l2-2h-1l1-2z",
    fill: "#e085b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 94v1zh-1z",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 95h1v-1l-1 1h-2 1v1-1h1",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 97v-1m0-1v1-1h1l-1 1v-1",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 101v-1l-1 1h1m0 1h-1 1m0 1h1-1m3 2-1 1h1m-1 1v-1m1 2h1-1m5 0-1 1h1v-1m0 1v1h1-1v-1m1 1h1-1",
    className: "Spain_svg__T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 95v-1h-1v-1h-1v1h1zh1z",
    className: "Spain_svg__S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 94h1z",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 93h-1zm-1-1v1z",
    className: "Spain_svg__S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 93v-1zm0-1v1z",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Spain_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 93v1zm0 0h-1v1h1zM75 94v-1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 93v1zm0 0h-1z",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 94h-1zm-1 0v1h1v-1z",
    className: "Spain_svg__S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 94h1z",
    className: "Spain_svg__V"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 95q1.5 0 0 0z",
    className: "Spain_svg__S"
  }))));
};
export default SvgSpain;